export default __webpack_public_path__ + "static/tts-2d0056485f9fca24de87c46a74a6450c.mp4";